import type { ComponentRef, Ref } from 'react';
import {
  KeyboardAwareScrollView,
  type KeyboardAwareScrollViewProps,
} from 'react-native-keyboard-controller';
import { StyleSheet } from 'react-native-unistyles';

const BOTTOM_OFFSET = 120;

export default function ModalKeyboardAwareScrollView({
  ref,
  ...props
}: KeyboardAwareScrollViewProps & {
  ref?: Ref<ComponentRef<typeof KeyboardAwareScrollView>>;
}) {
  return (
    <KeyboardAwareScrollView
      nestedScrollEnabled
      bottomOffset={BOTTOM_OFFSET}
      keyboardDismissMode="none"
      keyboardShouldPersistTaps="handled"
      ref={ref}
      {...props}
      style={style.scrollView}
    />
  );
}

const style = StyleSheet.create((_, rt) => ({
  scrollView: {
    flex: 1,
    marginBottom: rt.insets.bottom,
  },
}));
